import {Outlet, ScrollRestoration} from 'react-router';
import {Header} from '../components/shared/header/Header';
import {Footer} from '../components/shared/footer/Footer';
import {DialogContainer} from '../module/modal-container/components/dialog-container/dialog-container';
export function Layout() {
  return (
    <div style={{display: 'flex', minHeight: '100dvh', flexDirection: 'column'}}>
      <Header />
      <ScrollRestoration />
      <main style={{display: 'flex', flexGrow: 1, flexDirection: 'column'}}>
        <Outlet />
        <DialogContainer />
      </main>
      <Footer />
    </div>
  );
}
